export enum BookmarkType {
    Desktop = 0,
    RemoteApp = 1
}
